import angular from 'angular'
import ClientService from 'common/client.service'

import component from './about.component'

export default angular.module('about', [
  ClientService
]).component('about', component)
